<template>
  <div class="layout-bread">
    <div class="btn-con left-btn" @click="handleScroll(240)">
      <i class="fa fa-angle-left" />
    </div>
    <div
      class="btn-con right-btn"
      :class="{
        noAuth: !authList.includes('vms.homePage.listEquipmentStatusByFactory')
      }"
      @click="handleScroll(-240)"
    >
      <i class="fa fa-angle-right" />
    </div>
    <div
      class="bar-content"
      :class="{
        noAuth: !authList.includes('vms.homePage.listEquipmentStatusByFactory')
      }"
      ref="scrollOuter"
      @DOMMouseScroll="handlescroll"
      @mousewheel="handlescroll"
    >
      <div
        class="bar-scroll"
        ref="scrollBody"
        :style="{ left: tagBodyLeft + 'px' }"
      >
        <Tag
          type="dot"
          :color="isCurrent(homeUrl) ? 'blue' : ''"
          name="首页"
          @click.native="routeTo(homeUrl)"
          class="mr0"
        >
          首页
        </Tag>
        <Tag
          v-for="(page, index) in pages"
          :key="page.path"
          type="dot"
          :color="isCurrent(page.path) ? 'blue' : ''"
          :fade="false"
          closable
          @click.native="routeTo(page.fullPath)"
          @on-close.stop="removeItem(page, index)"
        >
          {{ page.title }}
        </Tag>
      </div>
    </div>
    <div
      class="audio-wrapper flex-row flex-vice-center"
      v-if="authList.includes('vms.homePage.listEquipmentStatusByFactory')"
    >
      <span>语音开关</span>
      <i-switch
        size="small"
        :value="playAudioFlag === '1'"
        @on-change="handlePlay"
      />
      <span>告警开关</span>
      <i-switch
        size="small"
        :value="showNotificationFlag === '1'"
        @on-change="handleOpen"
      />
      <!-- <span style="cursor:pointer" class="iconfont" :class="playAudioFlag==='0'?'icon-bofang':' icon-pause'" @click="handlePlay"></span> -->
    </div>
    <div class="bar-tool">
      <Dropdown style="margin-left: 20px">
        <Button type="primary" size="small">
          标签选项
          <Icon type="md-arrow-dropdown" />
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem @click.native="closeOther">关闭其他</DropdownItem>
          <DropdownItem @click.native="removeAll">关闭所有</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPages, addPage, removePage } from '@/store/pages'

export default {
  props: ['homeUrl'],
  data() {
    return {
      initItems: [],
      tagBodyLeft: 0,
      authList: [],
      showNotificationFlag: '0'
    }
  },
  mounted() {
    this.authList = JSON.parse(sessionStorage.getItem('authList'))
    this.showNotificationFlag = localStorage.getItem('showNotificationFlag')
    this.$watch(() => this.$route, currentRoute => {
      currentRoute.path !== this.homeUrl && addPage(currentRoute)
    }, { immediate: true })
  },
  computed: {
    ...mapGetters(['playAudioFlag']),
    pages: () => getPages()
  },
  methods: {
    handlePlay(e) {
      this.$store.commit('common/SET_PLAY_AUDIO_FLAG', e ? '1' : '0')
    },
    handleOpen(e) {
      //this.$store.commit("common/SET_PLAY_AUDIO_FLAG", e ? "1" : "0");
      localStorage.setItem('showNotificationFlag', e ? '1' : '0')
    },

    handlescroll(e) {
      var type = e.type
      let delta = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = e.wheelDelta ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScroll(delta)
    },
    handleScroll(offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth

      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      }
      else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {

          }
          else {
            this.tagBodyLeft = Math.max(
              this.tagBodyLeft + offset,
              outerWidth - bodyWidth
            )
          }
        }
        else {
          this.tagBodyLeft = 0
        }
      }
    },
    isCurrent(path) {
      return path === this.$route.path
    },
    routeTo(fullPath) {
      this.$router.push(fullPath)
      if (fullPath === this.homeUrl) return
      const page = this.pages.find(p => p.fullPath === fullPath)
      page && this.$emit('refreshUrl', page.path)
    },
    removeItem(page, index) {
      removePage(page)
      //删除是否当前
      if (this.isCurrent(page.path)) {
        const p = index === 0 ? { path: this.homeUrl, fullPath: this.homeUrl } : this.pages[index - 1]
        this.$router.push(p.fullPath)
        this.$emit('refreshUrl', p.path)
      }
    },
    closeOther() {
      const currentPage = getPages().find(page => this.isCurrent(page.path))
      // 选中的是首页，此时不会有当前页
      const route = currentPage && this.$router.resolve(currentPage).resolved
      removePage()
      route && addPage(route)
    },
    removeAll() {
      removePage()
      this.$route.path !== this.homeUrl && this.$router.push(this.homeUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/route-bar.vue